module.exports = {
  footerLink: 'http://app.culturebie.com'
};